'use client'

import { useState, useEffect } from 'react'
import { ShoppingBag } from 'lucide-react'
import { Button } from '@/components/Button'
import { useCartStore } from '@/stores/cartStore'

interface CartIconProps {
  className?: string
  showLabel?: boolean
}

export function CartIcon({ className, showLabel = false }: CartIconProps) {
  const { toggleCart, totalItems } = useCartStore()
  const [itemCount, setItemCount] = useState(0)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    setItemCount(totalItems())
  }, [totalItems])

  // Update count when cart changes
  useEffect(() => {
    if (mounted) {
      setItemCount(totalItems())
    }
  }, [totalItems, mounted])

  return (
    <Button
      variant="ghost"
      onClick={toggleCart}
      className={`relative ${className}`}
      title="Winkelwagen"
    >
      <ShoppingBag className="w-5 h-5" />
      
      {/* Item Count Badge - only show after hydration */}
      {mounted && itemCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-accent text-white text-xs font-medium rounded-full w-5 h-5 flex items-center justify-center min-w-[20px]">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
      
      {/* Optional Label */}
      {showLabel && (
        <span className="ml-2 hidden sm:inline">
          Winkelwagen
          {mounted && itemCount > 0 && ` (${itemCount})`}
        </span>
      )}
    </Button>
  )
}